import { render, staticRenderFns } from "./EditSensitiveWordDialog.vue?vue&type=template&id=7a3682ae&"
import script from "./EditSensitiveWordDialog.vue?vue&type=script&lang=js&"
export * from "./EditSensitiveWordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports